import { getNeutralValueSet } from '.';
import { PredefinedValueset, ValueSetId, ValueSets } from './types';
import { keyBy } from 'lodash';

export const CUSTOM_VALUE_SET_NAME = 'Custom';

import _valueSets from '@upright/common/data/value-sets.json';
import _nirValueSets from '@upright/common/data/value-sets-nir.json';

export const valueSets = _valueSets as ValueSets;
export const nirValueSets = _nirValueSets as ValueSets;

// OA: If you delete old ones from here, the key takeaways from old versions will probably crash the UI
export const predefinedValueSets: PredefinedValueset[] = [
  {
    id: ValueSetId.EQUAL_WEIGHTS,
    title: 'Equal weights',
    description: `This is the default value set, where each category is given the same weight.`,
    valueSet: getNeutralValueSet(),
    keyTakeawayText: 'no impact category in particular',
  },
  {
    id: ValueSetId.NIR_ASSET_OWNER,
    title: 'Asset owners',
    description: `Values of asset owners, based on Upright's annual Investor survey.`,
    valueSet: nirValueSets.NIR_ASSET_OWNER,
    keyTakeawayText: 'values similar to those of Asset Owners',
  },
  {
    id: ValueSetId.NIR_MILLENIAL,
    title: 'Millennials (b. 1980-99)',
    description: `Values of millennials, based on Upright's annual Impact at Work survey.`,
    valueSet: nirValueSets.NIR_MILLENIAL,
    keyTakeawayText: 'values similar to those of Millennials',
  },
  {
    id: ValueSetId.NIR_MOST_WANTED,
    title: 'Most wanted workforce',
    description: `Values of the most wanted workforce, based on Upright's annual Impact at Work survey.`,
    valueSet: nirValueSets.NIR_MOST_WANTED,
    keyTakeawayText: 'values similar to those of the most wanted workforce',
  },
  {
    id: ValueSetId.KNOWLEDGE_FIRST,
    title: 'Knowledge first',
    description: `Values that emphasize knowledge impacts over other impacts`,
    valueSet: valueSets.KNOWLEDGE_FIRST,
    keyTakeawayText: 'impacts on knowledge',
  },
  {
    id: ValueSetId.HEALTH_FIRST,
    title: 'Health first',
    description: `Values that emphasize health impacts over other impacts.`,
    valueSet: valueSets.HEALTH_FIRST,
    keyTakeawayText: `preventing and treating health issues`,
  },
  {
    id: ValueSetId.NIR_VALUE_FOR_SOCIETY,
    title: 'Society first',
    description: `Values that emphasize societal impacts over other impacts.    `,
    valueSet: nirValueSets.NIR_VALUE_FOR_SOCIETY,
    keyTakeawayText: 'societal impacts',
  },
  {
    id: ValueSetId.TAXES_AND_JOBS,
    title: 'Taxes and jobs are the real deal',
    description: `In this value set, we go traditional: paying taxes and employing
       people are seen as the central ways in which companies impact the world.`,
    valueSet: valueSets.TAXES_AND_JOBS,
    keyTakeawayText: 'creating tax income and jobs',
  },
  {
    id: ValueSetId.FINLAND,
    title: 'Government of Finland values',
    description: `The weights of the 19 impacts reflect how the Finnish government (2018 budget)
       and municipalities (2016 budget) impose taxes and spend money.`,
    valueSet: valueSets.FINLAND,
    keyTakeawayText: `the government of Finland's values`,
  },
  {
    id: ValueSetId.FIGHTING_CLIMATE_CHANGE,
    title: 'Fighting climate change',
    description: `The environment and especially greenhouse gas emissions are
     prioritized over health, society and knowledge.
     Replacing sources of emissions are further prioritized over reductions in emissions.`,
    valueSet: valueSets.FIGHTING_CLIMATE_CHANGE,
    keyTakeawayText: `fighting climate change`,
    hidden: true,
  },
];

export const valueSetsToShowUsers = predefinedValueSets.filter(d => !d.hidden);
export const valueSetsToShowTeam = [...predefinedValueSets];

const valueSetsById = keyBy(predefinedValueSets, d => d.id);

export function getValueSetById(id: ValueSetId): PredefinedValueset {
  return valueSetsById[id];
}
